import { type Modifiers } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getModifiersCount(modifiers: Modifiers): number {
  const { additions, removals, substitutions } = modifiers;

  return additions.length + removals.length + substitutions.length;
}
